/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { MobileNumberConfirmationModel } from '../../../../models/AccountModels';
import { sendSmsSecurityCode } from '../../../../core/api';
import { loginPageUrl } from '../../../../core/constants';
import MobileNumberField from '../../../../commonComponents/appForm/MobileNumberField';
import PageTitle from '../../common/PageTitle';
import AppForm from '../../common/AppForm';
import { hasValue } from '../../../../lib/lib';
import { useNavigateWithAppName } from '../../../common/NavigateWithAppName';

const MobileNumberConfirmationForm = (props: Props) => {
	const navigate = useNavigateWithAppName();
	const { email, securityToken } = props;

	const { signal } = new AbortController();

	const handleSubmit = async (model: MobileNumberConfirmationModel) => {
		await sendSmsCodeToMobile(email, model.mobileNumber, securityToken, navigate, signal, props.onSubmit);
		props.onSubmit(model.mobileNumber);
	};

	return (
		<>
			<PageTitle
				title="Two-factor authentication"
				subtitle="Enter your mobile number to protect your account with two-factor authentication."
			/>
			<AppForm onSubmit={handleSubmit} primaryButtonText="Continue" singleColumn>
				<MobileNumberField
					label="Mobile number"
					name="mobileNumber"
					required={false}
					validate={(value: string) => hasValue(value) || 'Please provide a valid mobile phone number.'}
				/>
			</AppForm>
		</>
	);
};

export default MobileNumberConfirmationForm;

interface Props {
	email: string;
	securityToken: string;
	onSubmit: (mobile: string) => void;
}

export const sendSmsCodeToMobile = async (
	email: string,
	mobileNumber: string,
	securityToken: string,
	navigate: any,
	signal: AbortSignal,
	onSuccess?: (mobile: string) => void
) => {
	const mobileNumberConfirmationModel: MobileNumberConfirmationModel = {
		email,
		mobileNumber,
		securityToken
	};
	const apiResult = await sendSmsSecurityCode(mobileNumberConfirmationModel, signal);
	if (!apiResult.succeeded)
		navigate(loginPageUrl, {
			state: { message: 'Mobile number verification timeout, please login and setup later.' } // TODO: Consider showing this in login page
		});
	else if (onSuccess) {
		onSuccess(mobileNumber);
	}
};
